export default __webpack_public_path__ + "static/media/media-residential-4.e0444e51.jpg";